import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import animatedgif from '../img/zoomies.gif'

function ImageSection() {
    
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={animatedgif} alt=""/>
            </div>
            <div className="content">
                <h4 className="img-text">Me, Myself & I</h4>
                <p className="paragraph">
                My name is Dwi Andika and I’m a Front-End Developer.
                Located in Tangerang, Indonesia. I have a passion for UI effects, 
                animations and creating intuitive, dynamic user experiences. I also have short of experience with Back-End such as Python and Databases (MySQL).
                <br/>
                <br/>
                Well-organised person, problem solver with high attention to detail.
                Fan of NBA, manga and TV series. In my free time, i learn to design and implement it for my website.     
                <br/>
                <br/>
                Interest about new technology especialy with front-end and design and working on ambitious projects with positive people.
                </p>
                <Bio>
                <BioTitle>Bio</BioTitle>
                <BioSection>
                    <BioYear>1998</BioYear>
                    Born in Jakarta, Indonesia.
                </BioSection>
                <BioSection>
                    <BioYear>2016</BioYear>
                    Graduated in high school (SMK PGRI 11) and start my journey.
                </BioSection>
                <BioSection>
                    <BioYear>2021</BioYear>
                    Graduated as Informatics Engineering at Satya Negara Indonesia University. Continuing my journey and start to build small single pages
                    website that are fast and easy to use.
                </BioSection>
                </Bio>
                <LinkText to='/contact'>Let’s make something special.</LinkText>
            </div>
        </ImageSectionStyled>
    )
}

const Bio = styled.div`
    padding: 1rem;
    border: 1px solid #c46500;
    position: relative;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
    max-width: 35rem;
`

const BioTitle = styled.h1`
    color: #c46500;
    margin-bottom: 1.5rem;
    text-align: left;
    font-size: 2rem;
`

const BioSection = styled.p`
    display: flex;
    margin-bottom: 5px;
    
`
const BioYear = styled.p`
    font-weight: bold;
    margin-right: 15px;
`

const LinkText = styled(Link)`
    color: #c46500;
    text-decoration: none;
    text-align: left;
    font-size: 17px;
    transition: 0.3s ease-in-out;

    @media screen and (max-width: 768px){
        padding: 1.2rem 2rem;
    }
    
    &:hover{
        color: #c43300;
        transition: 0.3s ease-in-out;
    }
`

const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5rem;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .ityped-cursor{
        animation: blink 1s infinite;
    }

    @keyframes blink {
        100%{
            opacity: 0;
        }
        50%{
            opacity: 1;
        }
    }
    .left-content{
        width: 65%;

        @media screen and (max-width: 768px){
                width: 50%;
                align-items: center;
                justify-content: center;
                margin-left: 40px;
            }

        img{
            width: 75%;
            object-fit: cover;
        }
    }

    .content{
        width: 100%;
        h4{
            font-size: 3rem;
            color: var(--white-color);
        }

        .img-text{
        color: #c46500;

        @media screen and (max-width: 768px){
            padding: 0 1rem;
            }
        }

        .paragraph{
            padding: 1.5rem 0rem;

            @media screen and (max-width: 768px){
                padding: 1.2rem 2rem;
    }
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;
export default ImageSection;
